import type { Student } from '@/api';

export const useStudentPolicy = (model: Ref<Student | undefined>) => {
    const { user, agentId, isAgency, permissions } = useCompany();
    const getPolicy = (model: Student | undefined) => {
        const isModel = model != null && (model?.id === user.value?.id || user.value?.id === model?.user_id);
        const isAssigned =
            isAgency.value &&
            (model?.handlers?.some(h => h.user_id === agentId.value) || permissions.value.manageStudents);

        const viewStudent = isAssigned || isModel;

        const viewApplications = true;

        const applyPrograms = isAssigned || isModel;

        const editDocuments = isAssigned || isModel;

        const uploadMedia = isAssigned || isModel;

        return {
            viewStudent,
            viewApplications,
            editDocuments,
            applyPrograms,
            uploadMedia,
        } as const;
    };

    const policy = computed(() => getPolicy(model.value));

    return { policy, getPolicy };
};
